import { RoutesConfig } from '../../../config/router/router';
import LazyLoad from '../../../core/common/LazyLoading/LazyLoading';
import { routes } from '../../../config/routes/routes';
import NotFoundPage from '../../../core/pages/error/NotFoundPage/NotFoundPage';
import React from 'react';

/* eslint-disable new-cap */
const EmployeesPage = LazyLoad(
  () => import('../../../app/pages/admin/Employee/EmployeesPage/EmployeesPage'),
);
const EmployeeCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Employee/EmployeeCreatePage/EmployeeCreatePage'
    ),
);
const EmployeeEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Employee/EmployeeEditPage/EmployeeEditPage'
    ),
);

const TravelersPage = LazyLoad(
  () => import('../../../app/pages/admin/Traveler/TravelersPage/TravelersPage'),
);
const TravelerCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Traveler/TravelerCreatePage/TravelerCreatePage'
    ),
);
const TravelerEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Traveler/TravelerEditPage/TravelerEditPage'
    ),
);
const TravelerViewPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Traveler/TravelerViewPage/TravelerViewPage'
    ),
);

const CompaniesPage = LazyLoad(
  () => import('../../../app/pages/admin/Company/CompaniesPage/CompaniesPage'),
);
const CompanyCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Company/CompanyCreatePage/CompanyCreatePage'
    ),
);
const CompanyEditPage = LazyLoad(
  () =>
    import('../../../app/pages/admin/Company/CompanyEditPage/CompanyEditPage'),
);
const CompanyViewPage = LazyLoad(
  () =>
    import('../../../app/pages/admin/Company/CompanyViewPage/CompanyViewPage'),
);

const TravelerManagerCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/TravelerManager/TravelerManagerCreatePage/TravelerManagerCreatePage'
    ),
);
const TravelerManagerEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/TravelerManager/TravelerManagerEditPage/TravelerManagerEditPage'
    ),
);

const EnquiriesPage = LazyLoad(
  () => import('../../../app/pages/admin/Order/EnquiriesPage/EnquiriesPage'),
);
const EnquiryEditPage = LazyLoad(
  () =>
    import('../../../app/pages/admin/Order/EnquiryEditPage/EnquiryEditPage'),
);

const QuotesPage = LazyLoad(
  () => import('../../../app/pages/admin/Order/QuotesPage/QuotesPage'),
);
const QuoteEditPage = LazyLoad(
  () => import('../../../app/pages/admin/Order/QuoteEditPage/QuoteEditPage'),
);

const AirportsPage = LazyLoad(
  () => import('../../../app/pages/admin/Airport/AirportsPage/AirportsPage'),
);
const AirlinesPage = LazyLoad(
  () => import('../../../app/pages/admin/Airline/AirlinesPage/AirlinesPage'),
);

const SuppliersPage = LazyLoad(
  () => import('../../../app/pages/admin/Supplier/SuppliersPage/SuppliersPage'),
);
const SupplierCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Supplier/SupplierCreatePage/SupplierCreatePage'
    ),
);
const SupplierEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Supplier/SupplierEditPage/SupplierEditPage'
    ),
);

const AccommodationsPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Accommodation/AccommodationsPage/AccommodationsPage'
    ),
);
const AccommodationCreatePage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Accommodation/AccommodationCreatePage/AccommodationCreatePage'
    ),
);
const AccommodationEditPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Accommodation/AccommodationEditPage/AccommodationEditPage'
    ),
);

const BookingsPage = LazyLoad(
  () => import('../../../app/pages/admin/Order/BookingsPage/BookingsPage'),
);
const BookingPage = LazyLoad(
  () => import('../../../app/pages/admin/Order/BookingPage/BookingPage'),
);

const OrdersOverviewPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/Order/OrdersOverviewPage/OrdersOverviewPage'
    ),
);

const CarHireSuppliersPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/CarHireSupplier/CarHireSuppliersPage/CarHireSuppliersPage'
    ),
);
const TransferVendorsPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/TransferVendor/TransferVendorsPage/TransferVendorsPage'
    ),
);
const RailSuppliersPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/RailSupplier/RailSuppliersPage/RailSuppliersPage'
    ),
);
const CruiseLinesPage = LazyLoad(
  () =>
    import(
      '../../../app/pages/admin/CruiseLine/CruiseLinesPage/CruiseLinesPage'
    ),
);
const CarTypesPage = LazyLoad(
  () => import('../../../app/pages/admin/CarType/CarTypesPage/CarTypesPage'),
);

const TasksPage = LazyLoad(
  () => import('../../../app/pages/admin/Task/TasksPage/TasksPage'),
);

export const APP_ROUTER_CONFIG: RoutesConfig = {
  auth: [],
  authNonAuth: [],
  admin: [
    {
      path: routes.admin.employees.list,
      element: <EmployeesPage />,
    },
    {
      path: routes.admin.employees.new,
      element: <EmployeeCreatePage />,
    },
    {
      path: routes.admin.employees.edit,
      element: <EmployeeEditPage />,
    },
    {
      path: routes.admin.travelers.list,
      element: <TravelersPage />,
    },
    {
      path: routes.admin.travelers.new,
      element: <TravelerCreatePage />,
    },
    {
      path: routes.admin.travelers.edit,
      element: <TravelerEditPage />,
    },
    {
      path: routes.admin.travelers.view,
      element: <TravelerViewPage />,
    },
    {
      path: routes.admin.companiesV2.list,
      element: <CompaniesPage />,
    },
    {
      path: routes.admin.companiesV2.new,
      element: <CompanyCreatePage />,
    },
    {
      path: routes.admin.companiesV2.edit,
      element: <CompanyEditPage />,
    },
    {
      path: routes.admin.companiesV2.view,
      element: <CompanyViewPage />,
    },
    {
      path: routes.admin.travelerManagers.new,
      element: <TravelerManagerCreatePage />,
    },
    {
      path: routes.admin.travelerManagers.edit,
      element: <TravelerManagerEditPage />,
    },
    {
      path: routes.admin.enquiries.list,
      element: <EnquiriesPage />,
    },
    {
      path: routes.admin.enquiries.edit,
      element: <EnquiryEditPage />,
    },
    {
      path: routes.admin.suppliers.list,
      element: <SuppliersPage />,
    },
    {
      path: routes.admin.suppliers.new,
      element: <SupplierCreatePage />,
    },
    {
      path: routes.admin.suppliers.edit,
      element: <SupplierEditPage />,
    },
    {
      path: routes.admin.accommodations.list,
      element: <AccommodationsPage />,
    },
    {
      path: routes.admin.accommodations.new,
      element: <AccommodationCreatePage />,
    },
    {
      path: routes.admin.accommodations.edit,
      element: <AccommodationEditPage />,
    },
    {
      path: routes.admin.quotes.list,
      element: <QuotesPage />,
    },
    {
      path: routes.admin.quotes.edit,
      element: <QuoteEditPage />,
    },
    {
      path: routes.admin.bookings.list,
      element: <BookingsPage />,
    },
    {
      path: routes.admin.bookings.view,
      element: <BookingPage />,
    },
    {
      path: routes.admin.orders.overview,
      element: <OrdersOverviewPage />,
    },
    {
      path: routes.admin.carHireSuppliers.list,
      element: <CarHireSuppliersPage />,
    },
    {
      path: routes.admin.transferVendors.list,
      element: <TransferVendorsPage />,
    },
    {
      path: routes.admin.railSuppliers.list,
      element: <RailSuppliersPage />,
    },
    {
      path: routes.admin.cruiseLines.list,
      element: <CruiseLinesPage />,
    },
    {
      path: routes.admin.carTypes.list,
      element: <CarTypesPage />,
    },
    {
      path: routes.admin.airports.list,
      element: <AirportsPage />,
    },
    {
      path: routes.admin.airlines.list,
      element: <AirlinesPage />,
    },
    {
      path: routes.admin.tasks.list,
      element: <TasksPage />,
    },
    {
      path: '*',
      element: <NotFoundPage />,
    },
  ],
  adminNonAuth: [],
};
